import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_2ig5ozgc: FaireBrandEntity = {
  token: "b_2ig5ozgc",
  type: "brand",
  name: "Vanilla Monkey",
  avatarUrl:
    "https://cdn.faire.com/fastly/197679784f9e57f98fa30100afa401965a1f19ea370321727fcc1249c5170d76.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/c46f072258faca9b59f58e4a6b7a56ebb96251a9b6ecc3d5e1292528dcf6adb5.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/197679784f9e57f98fa30100afa401965a1f19ea370321727fcc1249c5170d76.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/c46f072258faca9b59f58e4a6b7a56ebb96251a9b6ecc3d5e1292528dcf6adb5.jpeg",
  location: "Los Angeles, CA, USA",
  minimumOrderDollars: 100,
  rating: 4.8,
  reviewCount: 2590,
  isTopShop: true,
  isInsider: true,
  description:
    "VANILLA MONKEY offers the latest trends and various styles to fit all sizes from junior contemporary to plus size.\nWe specialize in fashionable wholesale apparel and accessories, with an inventory that is always expanding and up-to-date. New styles are added daily to represent the latest trends.\n\nExplore our online collection of wholesale clothes, from trendy tops and pants to dresses, skirts, jackets, and more. We also offer a wide selection of stylish plus-size clothing. Our collection proves that fashionable apparel can be affordable.\n\n",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:44:05.997Z",
    importedBy: "entity-db-cli",
  },
};
